<template>
  <ScrollEventList
    v-if="recommendSaleEvents.length > 0"
    event-list-title="先着割引中イベント"
    sub-title="今予約がおトク！"
    event-link-append-query="from_topsale"
    use-opix="opixAPIRecommendEventSale"
    :events="recommendSaleEvents"
    :recommend-version="recommendVersionSale"
    :showed-block="SALE_SHOWED_BLOCK"
  />
</template>

<script lang="ts">
import { type Ref, type ComputedRef, ref, defineAsyncComponent } from 'vue'

import { useMainStore } from '@/store'
import TrackingUserMixin from '@/utils/mixins/TrackingUserMixin'
import { OPIX_EVENTS_CHECK_POINTS_RECOMMEND_SALE } from '@/utils/constants/opixTracking'

const ScrollEventList = defineAsyncComponent(() => import('@/components/event/ScrollEventList.vue'))

export default defineNuxtComponent({
  async setup() {
    const SALE_SHOWED_BLOCK = 'AIRecommend_event_sale'

    const store = useMainStore()

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const recommendSaleEvents: Ref<any[]> = ref([])
    const recommendVersionSale: Ref<null | string> = ref(null)
    const baseCheckPoints = ref(OPIX_EVENTS_CHECK_POINTS_RECOMMEND_SALE)

    const profileUser: ComputedRef<null | { prefecture_slug: string }> = computed(() => store.$state.my_profile)

    /* Fetch data */
    const globalCookie = new GlobalCookie(store)
    const prefectureSlug = globalCookie.get('prefecture') || profileUser.value?.prefecture_slug || 'tokyo'

    const query = { prefecture_slug: prefectureSlug }

    const { data } = await store.dispatch('apiGet', `recommend_event_topsale/${buildQueryString(query)}`)
    recommendSaleEvents.value = data.events
    recommendVersionSale.value = data.recommend_version

    return {
      SALE_SHOWED_BLOCK,
      recommendSaleEvents,
      recommendVersionSale,
      baseCheckPoints,
      profileUser
    }
  },
  components: {
    ScrollEventList
  },
  mixins: [TrackingUserMixin]
})
</script>
